import {ReactComponent as QrCodeIcon} from './qrCode.svg'

function QrCode() {
  return <QrCodeIcon />
}

export default QrCode
